module.exports = __webpack_public_path__ + "static/media/Lynk_Logo.c77cedd1.svg";